export default __webpack_public_path__ + "media/zurb/img/ecommerce/getup_pdp-3d743fb0cbaa57a35695238cf73eaf2e.png";